import { __assign, __extends } from "tslib";
import { isPromise } from '../../../common';
import * as React from 'react';
import { namespacedClassnames } from '../../../common/namespace-classes';
import { Tooltip } from '../../tooltip/tooltip';
/** @deprecated please use \<Button/> */
var DeprecatedLinkButton = /** @class */ (function (_super) {
    __extends(DeprecatedLinkButton, _super);
    function DeprecatedLinkButton() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.unMounted = false;
        _this.state = {
            loading: false
        };
        _this.startLoading = function () {
            if (!_this.unMounted) {
                _this.setState({ loading: true });
            }
        };
        _this.stopLoading = function () {
            if (!_this.unMounted) {
                _this.setState({ loading: false });
            }
        };
        _this.onClick = function (e) {
            var result = _this.props.onClick(e);
            if (result && isPromise(result)) {
                _this.startLoading();
                result.then(_this.stopLoading, _this.stopLoading);
            }
        };
        return _this;
    }
    DeprecatedLinkButton.prototype.componentWillUnmount = function () {
        this.unMounted = true;
    };
    DeprecatedLinkButton.prototype.render = function () {
        var props = this.props;
        var loading = this.state.loading;
        var disabled = props.disabled || loading;
        var classNames = namespacedClassnames('deprecated-link-button', { disabled: disabled }, props.type, props.className);
        var disabledMsg = (typeof disabled === 'string') ? disabled : '';
        var buttonComp = (React.createElement("button", { onClick: this.onClick, disabled: !!disabled, className: classNames }, props.children));
        return !!disabledMsg ? (React.createElement(Tooltip, { body: disabledMsg, relativeToBody: true }, buttonComp)) : buttonComp;
    };
    return DeprecatedLinkButton;
}(React.PureComponent));
export { DeprecatedLinkButton };
export var DeprecatedDangerLinkButton = function (props) {
    return React.createElement(DeprecatedLinkButton, __assign({}, props, { type: 'danger' }), props.children);
};
//# sourceMappingURL=link-button.js.map